import { RouteConfig } from 'vue-router'

const Index = () => import('../../src/activity/cooking-master-boy/Index.vue')
const Winners = () => import('../../src/activity/cooking-master-boy/winners/Index.vue')
const Vegeteal = () => import('../../src/activity/cooking-master-boy/Vegeteal.vue')
const CookingList = () => import('../../src/activity/cooking-master-boy/cooking-list/Index.vue')
const LotteryRewards = () => import('../../src/activity/cooking-master-boy/LotteryRewards.vue')
const TeamScoreRecords = () => import('../../src/activity/cooking-master-boy/TeamScoreRecords.vue')
const DishIngredientRecords = () => import('../../src/activity/cooking-master-boy/DishIngredientRecords.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/cooking-master-boy',
  name: 'activity_cooking_master_boy',
  component: Index,
  redirect: '/activity/cooking-master-boy/winners',
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '中华小当家 厨神大作战',
  },
}

export const winnersRoute: RouteConfig = {
  path: '/activity/cooking-master-boy/winners',
  name: 'activity_cooking_master_boy_winners',
  component: Winners,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '中华小当家 厨神大作战',
  },
}

export const vegetealRoute: RouteConfig = {
  path: '/activity/cooking-master-boy/vegeteal',
  name: 'activity_cooking_master_boy_vegeteal',
  component: Vegeteal,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '偷菜',
  },
}

export const cookingListRoute: RouteConfig = {
  path: '/activity/cooking-master-boy/cooking-list',
  name: 'activity_cooking_master_boy_cooking_list',
  component: CookingList,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '中华小当家 厨神大作战',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/cooking-master-boy/lottery-rewards',
  name: 'activity_cooking_master_boy_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const teamScoreRecordsRoute: RouteConfig = {
  path: '/activity/cooking-master-boy/team-score-records',
  name: 'activity_cooking_master_boy_team_score_records',
  component: TeamScoreRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '人气值明细',
  },
}

export const dishIngredientRecordsRoute: RouteConfig = {
  path: '/activity/cooking-master-boy/dish-ingredient-records',
  name: 'activity_cooking_master_boy_dish_ingredient_records',
  component: DishIngredientRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '食材明细',
  },
}

export default [
  indexRoute,
  winnersRoute,
  vegetealRoute,
  cookingListRoute,
  lotteryRewardsRoute,
  teamScoreRecordsRoute,
  dishIngredientRecordsRoute,
]
